import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Frame } from '../InlineCard/Frame';
export class CardLinkView extends React.PureComponent {
  render() {
    return /*#__PURE__*/React.createElement(Frame, _extends({
      withoutBackground: true
    }, this.props), this.props.placeholder || this.props.link);
  }

}